import React from 'react';

import CatalogShell from './CatalogShell';

const TaskRewardTypes: React.FC = () => (
  <CatalogShell
    slug="task-reward-types"
    title="Task reward types"
    breadcrumbLabel="Task reward types"
    emptyBody="Task reward types enumerate what a completed task pays out — dollars, points, sweepstakes entries. Referenced by task_reward rows across tenants."
    addCtaLabel="Add first reward type"
  />
);

export default TaskRewardTypes;
